module.exports = __webpack_public_path__ + "img/whiterussian.52a9ba6a.jpg";